export type ResourceCalendarMonthGridTranslation = {
  dayAriaLabel: string;
  fullDay: string;
  gridAriaLabel: string;
  moreChips: string;
  phase: {
    assembly: string;
    disassembly: string;
  };
  status: {
    confirmed: string;
    free: string;
    tentative: string;
  };
  weekday: {
    friday: string;
    monday: string;
    saturday: string;
    sunday: string;
    thursday: string;
    tuesday: string;
    wednesday: string;
  };
};

export const resourceCalendarMonthGridTranslation: ResourceCalendarMonthGridTranslation = {
  dayAriaLabel: 'Wybierz dzień {{date}}',
  fullDay: 'Cały dzień',
  gridAriaLabel: 'Kalendarz miesięczny zajętości elementów słownika',
  moreChips: '+{{count}} więcej',
  phase: {
    assembly: 'Montaż',
    disassembly: 'Demontaż',
  },
  status: {
    confirmed: 'Rezerwacja potwierdzona',
    free: 'Wolny',
    tentative: 'Rezerwacja wstępna',
  },
  weekday: {
    friday: 'Pt',
    monday: 'Pn',
    saturday: 'So',
    sunday: 'Nd',
    thursday: 'Cz',
    tuesday: 'Wt',
    wednesday: 'Śr',
  },
};
